import {
  CLICKABLE_LAYER_IDS,
  LAYER_ID_POINTS,
  LAYER_ID_POLYGON_DIAMONDS,
  LAYER_ID_POLYGONS,
  LAYER_ID_POLYGON_OUTLINE
} from '@root/constants'

const LAYER_CLICK_PRIORITY = {
  [LAYER_ID_POINTS]: 0,
  [LAYER_ID_POLYGON_DIAMONDS]: 1,
  [LAYER_ID_POLYGONS]: 2,
  [LAYER_ID_POLYGON_OUTLINE]: 3
}

const POLYGON_AREA_LAYER_IDS = new Set([
  LAYER_ID_POLYGON_DIAMONDS,
  LAYER_ID_POLYGONS,
  LAYER_ID_POLYGON_OUTLINE
])

const CLICK_BUFFER_PX = 10

export function queryClickableFeatures(map, point) {
  const bbox = [
    [point.x - CLICK_BUFFER_PX, point.y - CLICK_BUFFER_PX],
    [point.x + CLICK_BUFFER_PX, point.y + CLICK_BUFFER_PX]
  ]

  return map.queryRenderedFeatures(bbox, { layers: CLICKABLE_LAYER_IDS })
}

function dedupeFeaturesBySiteId(features) {
  const bySiteId = new Map()

  features.forEach((feature) => {
    const siteId = String(feature.properties.site_id)
    const existing = bySiteId.get(siteId)
    const featurePriority = LAYER_CLICK_PRIORITY[feature.layer.id] ?? 99
    const existingPriority = existing ? (LAYER_CLICK_PRIORITY[existing.layer.id] ?? 99) : 99

    if (!existing || featurePriority < existingPriority) {
      bySiteId.set(siteId, feature)
    }
  })

  return bySiteId
}

function isPolygonAreaLayer(layerId) {
  return POLYGON_AREA_LAYER_IDS.has(layerId)
}

function findBestPolygonFeatureForSite(features, siteId) {
  const polygonFeatures = features.filter(
    (feature) => String(feature.properties.site_id) === siteId && isPolygonAreaLayer(feature.layer.id)
  )

  if (polygonFeatures.length === 0) return null

  return polygonFeatures.reduce((best, feature) => {
    if (!best) return feature

    const featurePriority = LAYER_CLICK_PRIORITY[feature.layer.id] ?? 99
    const bestPriority = LAYER_CLICK_PRIORITY[best.layer.id] ?? 99

    return featurePriority < bestPriority ? feature : best
  })
}

export function pickClickFeature(features) {
  if (features.length === 0) return null

  const dedupedBySiteId = dedupeFeaturesBySiteId(features)
  const seenSiteIds = new Set()

  for (const feature of features) {
    const siteId = String(feature.properties.site_id)
    if (seenSiteIds.has(siteId)) continue
    seenSiteIds.add(siteId)

    const polygonFeature = findBestPolygonFeatureForSite(features, siteId)
    if (polygonFeature) return polygonFeature
  }

  const topmostSiteId = String(features[0].properties.site_id)
  return dedupedBySiteId.get(topmostSiteId) ?? features[0]
}
